"use strict";

import $ from "jquery";

require('./main.js');

function clickMarker(id) {
    if($("#"+id)) {
        $("#"+id).click();
    }
}

function setMarkerBounce(id) {
    removeMarkerBounce();
    if(typeof window._markers != "undefined") {
        window._markers[id].setAnimation(google.maps.Animation.BOUNCE);
    }
};

function removeMarkerBounce() {
    for (var idx in window._markers) {
        var itm = window._markers[idx];
        itm.setAnimation(null);
    }
};

function recentreMap() {
    if (typeof window._map == 'undefined') {
        return;
    }

    // Check if centreLat centreLng and mapZoom are set explicityly otherwise set default one
    if($(document).find("#expert_map").data('centrelat') && $(document).find("#expert_map").data('centrelng') && $(document).find("#expert_map").data('mapzoom')) {
        window._map.setZoom($(document).find("#expert_map").data('mapzoom'));
        window._map.setCenter({ lat: $(document).find("#expert_map").data('centrelat'), lng: $(document).find("#expert_map").data('centrelng') });
    } else if(window._members) {
        var latlngbounds = new google.maps.LatLngBounds();

        for (var i = 0; i < window._members.length; i++) {
            latlngbounds.extend(window._members[i]['position']);
        }

        window._map.fitBounds(latlngbounds);

    } else {
        window._map.setZoom(6);
        window._map.setCenter({
            lat: -40.900557,
            lng: 169.885971
        });
    }
    return false;
};


function initExpertMap() {
    if (document.getElementById('expert_map')){

        var myLatlng = new google.maps.LatLng(-36.623589,174.6774864);

        var mapOptions = {
            maxZoom: 17,
            center: myLatlng,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            scrollwheel: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#555555"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f9f9f9"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#ccedf9"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        };

        var map = new google.maps.Map(document.getElementById("expert_map"), mapOptions);

        window._map = map;

        var iconBase = '/images/icons/';

        var iconSize = new google.maps.Size(36,36);
        var iconOrigin = new google.maps.Point(0,0);

        var icons = {
            plumbing: {
                icon: iconBase + 'plumbing.svg'
            },
            electrical: {
                icon: iconBase + 'electrical.svg'
            },
            'plumbing - electrical': {
            icon: iconBase + 'laser-symbol.png'
        },
        };

        var markerLayer = new google.maps.OverlayView();
        markerLayer.draw = function () {
            this.getPanes().markerLayer.classList.add('marker-layer');
        };
        markerLayer.setMap(map);

        var marker = [];
        window._members = [];
        window._markers = [];
        $( ".js-member" ).each(function( key, value ) {

            // Prototype markers
            marker = new google.maps.Marker({
                position: new google.maps.LatLng($(value).data("lat"),$(value).data("long")),
                map: map,
                icon: {
                    url: icons[$(value).data("category")].icon,
                    scaledSize: iconSize,
                    origin: iconOrigin
                },
                optimized: false
            });

            marker.addListener('click', function() {
                clickMarker($(value).attr("id"));
            });

            window._members.push({
                position: new google.maps.LatLng($(value).data("lat"),$(value).data("long")),
                type: $(value).data("category")
            });

            window._markers[key] = marker;


            // If some member is active alrady need to set animation for that
            if($(value).hasClass('is-active')) {
                setMarkerBounce(key);
            }

        });

        recentreMap();

    }
}
window.initExpertMap = initExpertMap;


$(document).ready(function() {
    const mapsUrl = `//maps.googleapis.com/maps/api/js?key=AIzaSyCZZzSTz0JG43VOQ6QVz9FsLwrPGCqEYQw&callback=initExpertMap`;
    const mapsScript = document.createElement('script');
    mapsScript.async = true;
    mapsScript.src = mapsUrl;
    document.querySelector('head').appendChild(mapsScript);

    // Submit form on change of filter
    $(".js-map-filter-input").on('change', function (e) {
        $(this).closest('form').submit();
    });


    if ($.support.pjax) {
        $.pjax.defaults.timeout = 60000;
        $.pjax.defaults.scrollTo = false;
        $.pjax.defaults.push = true;

        $(document).on('submit', '.js-map-filter', function (event) {
            $.pjax.submit(event, '.js-map-results', {
                fragment: '.js-map-results',
            });
        });

        $('.js-map-results').on('pjax:start', function () {
            $(".js-map-results").html("<div class='loading-spinner'><i></i><i></i><i></i></div>");
        });

        $('.js-map-results').on('pjax:complete', function () {
            initExpertMap();
        });
    }

    $(document).on("click", ".js-member", function (event) {

        // PJAX is doing weired thing here, so I need to put this class on view details button for mobile to prevenet PJAX and open the URL
        if(!$(event.target).hasClass("js-mobile-cta")) {
            $('.js-expert-infobox').html("<div class='p-8 relative'><div class='loading-spinner'><i></i><i></i><i></i></div></div>");

            $(".js-member").removeClass("is-active");
            $(this).addClass("is-active");

            var newUrl = $('.js-map-filter').attr("action")+"?"+$('.js-map-filter').serialize()+"&member="+$(this).attr("id");
            $.pjax.reload('.js-expert-infobox', {
                fragment: '.js-expert-infobox',
                url: newUrl
            });

            setMarkerBounce($(this).data("idx"));
        }

        
        //
        // $('.js-expert-infobox').on('pjax:start', function () {
        //     $('.js-expert-infobox').html("<div class='p-8 relative'><div class='loading-spinner'><i></i><i></i><i></i></div></div>");
        // });
        //
        // $('.js-expert-infobox').on('pjax:start', function () {
        //     $('.js-expert-infobox').html("<div class='p-8 relative'><div class='loading-spinner'><i></i><i></i><i></i></div></div>");
        // });

    });
    $(document).on("click", ".js-close-custominfo-window", function (event) {

        $('.js-expert-infobox').html("");
        $(".js-member").removeClass("is-active");

        var newUrl = $('.js-map-filter').attr("action")+"?"+$('.js-map-filter').serialize();
        $.pjax.reload('.js-expert-infobox', {
            fragment: '.js-expert-infobox',
            url: newUrl
        });

        $(".js-member").removeClass("is-active");
        removeMarkerBounce();

    })
});